import React from 'react';
import 'twin.macro';
import SimpleModal from '@teetsh/app/src/components/SimpleModal';
import { SwitchToggle } from '@teetsh/app/src/components/Form/SwitchToggle';
import { useCJConfigurationDisplay } from 'containers/CahierJournal/useCJConfigurationDisplay';
import { useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function AIContextualActionsModal({ isOpen, onClose }: Props) {
  const { t } = useTranslation(['common']);
  const { aiPaused, setAIPaused } = useCJConfigurationDisplay();

  return (
    <SimpleModal
      isOpen={isOpen}
      title={t('buttons.configureContextualActions')}
      closeModalFct={onClose}
      intent="none"
      validateTitle={t('buttons.close')}
      validateAction={onClose}
      noCancel
    >
      <div tw="py-2">
        <SwitchToggle
          label={t('buttons.showContextualActions')}
          checked={!aiPaused}
          onChange={() => setAIPaused(!aiPaused)}
        />
      </div>
    </SimpleModal>
  );
}
